import { render, staticRenderFns } from "./DeptVideoRecord.vue?vue&type=template&id=0f32a121&scoped=true"
import script from "./DeptVideoRecord.vue?vue&type=script&lang=js"
export * from "./DeptVideoRecord.vue?vue&type=script&lang=js"
import style0 from "./DeptVideoRecord.vue?vue&type=style&index=0&id=0f32a121&prod&scoped=true&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32a121",
  null
  
)

export default component.exports